import { useContext } from 'react';

import { ForageContext } from './ForageContext';

function useForage() {
    const context = useContext(ForageContext);

    if (!context) {
        throw new Error('useForage must be used within a ForageProvider');
    }

    return context;
}

export default useForage;
